import { render, staticRenderFns } from "./choosetype.vue?vue&type=template&id=1ad26042&scoped=true&"
import script from "./choosetype.vue?vue&type=script&lang=js&"
export * from "./choosetype.vue?vue&type=script&lang=js&"
import style0 from "./choosetype.vue?vue&type=style&index=0&id=1ad26042&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad26042",
  null
  
)

export default component.exports